export default "__VITE_ASSET__gwcViJIT__"